import { TailwindWrapper } from "@utils/TailwindWrapper";
import { Icon, Text, Button } from "@ui-component-library";
import MediaSelector from "../editor/fields/MediaSelector";
import ColorSelector from "../editor/fields/ColorSelector";

const HeroBigImage = (props) => {
  return (
    <TailwindWrapper>
      <div
        className={`w-full ${props.backgroundColor} bg-cover ${props.backgroundImagePosition}`}
        style={{
          backgroundImage: props.gradientOverlay && props.gradientOverlay !== "none"
          ? `${props.gradientOverlay}, url("${props.backgroundImage}")`
          : `url("${props.backgroundImage}")`
        }}
      >
        <section className='w-full min-h-screen py-3 container flex items-center justify-center'>
          <div className="w-[576px] px-2 max-w-full flex items-center justify-center flex-wrap">
          <Text tw variant="text-4xl/leading-normal/medium" className="lg:text-7xl text-spring-yellow-500 w-100 text-center mb-8">{props.mainText}</Text>
          <Text tw variant="text-lg/leading-normal/normal" className="text-white-50 w-100 text-center mb-8">{props.subText}</Text>
          <Button tw variant="primary" onClick={() => {window.location.href=props.buttonHref;}}>
            {props.buttonText}
            <Icon tw name="ArrowRightSimple" className="fill-white-500" />
          </Button>
          </div>
        </section>
      </div>
      
    </TailwindWrapper>
  );
};

HeroBigImage.defaultProps = {
  mainText: "Framtidens skogsägande börjar här",
  subText: "Få full kontroll över din fastighet. Treebula ger dig alla möjligheter att fatta trygga beslut och optimera din skogs framtid.",
  buttonHref: "/min-skog/",
  buttonText: "Kom igång",
  stretchBackgroundImage: null,
  backgroundImagePosition: 'bg-center-center',
  backgroundColor: 'white-50',
  gradientOverlay: "none",
};

HeroBigImage.fields = {
  mainText: {
    type: "textarea",
  },
  subText: {
    type: "textarea",
  },
  buttonText: {
    type: "text",
  },
  buttonHref: {
    type: "text",
  },
  backgroundImage: {
    type: "custom",
    render: ({ name, onChange, value }) => <MediaSelector name={name} onChange={onChange} value={value} />,
  },
  backgroundImagePosition: {
    type: "select",
    options: ["top", "bottom", "center"].reduce((acum, item) => {
        ["left", "right", "center"].forEach((item2) => {
            acum.push({label:"bg-"+item+"-"+item2, value:"bg-"+item+"-"+item2})
        })
        return acum;
    }, [{label:"bg-top", value:"bg-top"}, {label:"bg-bottom", value:"bg-bottom"}, {label:"bg-center", value:"bg-center"}, {label:"bg-left", value:"bg-left"}, {label:"bg-right", value:"bg-right"}])
  }, 
  backgroundColor: {
    type: "custom",
    render: (props) => <ColorSelector {...props} />
  },
  gradientOverlay: {
    type:"select",
    options: [
      { label: "None", value: "none" },
      { label: "Linear overlay (50%)", value: `var(--background-image-linear-overlay-50, transparent)` }, 
    ],
  }
};

export default HeroBigImage;
